import DaysComponent from 'ember-power-calendar/components/power-calendar-range/days';

import { set } from '@ember/object';

export default class BvCalendarRange extends DaysComponent {
  _updateFocused(id: string) {
    if (!this.isDestroyed) {
      set(this, 'focusedId', id);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCalendar::Range': typeof BvCalendarRange;
    'bv-calendar/range': typeof BvCalendarRange;
  }
}
